import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import ApplicantInfoList, { useIsPfpMasked } from 'src/components/ResumeCard/Header/ApplicantInfoList';
import CommunicationStatusList from 'src/components/ResumeCard/Header/CommunicationStatusList';
import { ResumeCardData } from 'src/models/resumeCard';

interface Props {
    applicantInfoList: Array<JSX.Element>;
    communicationStatusList: Array<JSX.Element>;
    isVisited: boolean;
    resume: ResumeCardData;
    isPfpVacancy: boolean | null;
}

const ApplicantInfoAndStatusList: FC<Props> = ({
    applicantInfoList,
    communicationStatusList,
    isVisited,
    resume,
    isPfpVacancy,
}) => {
    const shouldShowInfoList = applicantInfoList.length > 0;
    const shouldShowStatusList = communicationStatusList.length > 0;
    const isPfpMasked = useIsPfpMasked({
        permission: resume._attributes.permission,
        isPfpVacancy,
        hasPfpTopics: resume.hasPfpTopics,
    });

    return (
        <>
            {(shouldShowInfoList || shouldShowStatusList) && <VSpacing default={8} />}
            {shouldShowInfoList && (
                <ApplicantInfoList isVisited={isVisited} list={applicantInfoList} isPfpMasked={isPfpMasked} />
            )}
            {shouldShowStatusList && (
                <CommunicationStatusList list={communicationStatusList} startFromDivider={shouldShowInfoList} />
            )}
        </>
    );
};

export default ApplicantInfoAndStatusList;
